import {
  createSigninReturnState,
  readSigninReturnTo,
  type SigninLocation,
  type SigninReturnState,
} from "@novemai/identity-sdk";

export const getReturnTo = readSigninReturnTo;

/** Capture the current route both on initial sign-in and session recovery. */
export function getSigninState(location: SigninLocation = window.location): SigninReturnState {
  return createSigninReturnState(location);
}
